<template lang="pug">
  div.card-graph#grafico-unidade
    p.graph-title {{dados.numeroOS}}
    vc-donut(
      v-bind="graphProps"
      @section-mouseover="displaySectionValue"
      @section-mouseleave="resetSectionValue"
      :valores="graficoDados"
    )
    h1.section-value {{sectionValue}}
    div.wrap
      p(@click="showDetails(dados.idOS)").os-link Ver mais &rsaquo;
</template>

<script>

export default {
  props: {
    dados: {
      required: true
    }
  },

  data () {
    return {
      graphProps: {
        size: 100,
        sections: [],
        thickness: 35,
        hasLegend: false,
        total: 0
      },
      sectionValue: ''
    }
  },

  computed: {
    graficoDados () {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.graphProps.sections = [
        {value: this.dados.totalProcessosTramitados, label: 'Processos tramitados', color: '#33B281'},
        {value: this.dados.totalProcessosPendentes, label: 'Processos pendentes', color: '#DCDCDC'}
      ]

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.graphProps.total = this.dados.totalProcessos

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.sectionValue = this.dados.totalProcessos

      return true
    }
  },

  methods: {
    displaySectionValue (section) {
      this.sectionValue = section.value
    },

    resetSectionValue () {
      this.sectionValue = this.dados.totalProcessos
    },

    showDetails (osId) {
      this.$router.push(`detalhes/os/${osId}`)
    }
  }
}
</script>

<style lang="scss" scoped>
.card-graph {
  width: 200px;
  height: 250px;
  word-wrap: break-word;
  white-space: pre-wrap;
  word-break: break-word;
  padding: 10px;
  border-radius: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.graph-title {
  font-size: 0.8rem;
  text-align: center;
  font-weight: 900;
  height: 70px;
}

.section-value {
  position: relative;
  top: -90px;
  margin: 21.5px auto -70px;
  text-align: center;
  width: 50px;
}

.wrap {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.os-link {
  color: #2b78de !important;
  cursor: pointer;
}

#grafico-unidade >>> .cdc-filler:hover {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/screens/relatorios/components/os/Grafico.vue